import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../assets/page-image/dqly/banner.jpg';
const _hoisted_1 = {
  class: "dqly-detail-wrapper"
};
const _hoisted_2 = {
  class: "dqly-detail-page"
};
const _hoisted_3 = {
  key: 0,
  class: "loading"
};
const _hoisted_4 = {
  key: 1,
  class: "detail-content"
};
const _hoisted_5 = {
  class: "detail-title"
};
const _hoisted_6 = {
  class: "detail-info"
};
const _hoisted_7 = {
  key: 0,
  class: "info-item"
};
const _hoisted_8 = {
  key: 1,
  class: "info-item"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 0,
  class: "detail-attachment"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "back-btn-wrapper"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getPartyNewsDetail } from '@/api/party';
export default /*@__PURE__*/_defineComponent({
  __name: 'DqlyDetail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const newsDetail = ref({
      id: 0,
      categoryId: 0,
      title: '',
      subtitle: '',
      summary: '',
      content: '',
      contentText: '',
      coverImage: '',
      author: '',
      publishTime: '',
      attachment: ''
    });
    // 获取新闻详情
    const getDetail = async () => {
      const id = route.params.id;
      if (!id) {
        console.error('缺少新闻ID');
        return;
      }
      loading.value = true;
      try {
        const res = await getPartyNewsDetail(id);
        // console.log('详情数据：', res);
        if (res.data) {
          newsDetail.value = res.data;
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    };
    // 返回列表
    const goBack = () => {
      router.back();
    };
    // 页面加载时获取数据
    onMounted(() => {
      getDetail();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "党群园地",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("h1", _hoisted_5, _toDisplayString(newsDetail.value.title), 1), _createElementVNode("div", _hoisted_6, [newsDetail.value.author ? (_openBlock(), _createElementBlock("span", _hoisted_7, "作者：" + _toDisplayString(newsDetail.value.author), 1)) : _createCommentVNode("", true), newsDetail.value.publishTime ? (_openBlock(), _createElementBlock("span", _hoisted_8, "发布时间：" + _toDisplayString(formatDate(newsDetail.value.publishTime)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "detail-text",
        innerHTML: newsDetail.value.content
      }, null, 8, _hoisted_9), newsDetail.value.attachment ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[0] || (_cache[0] = _createElementVNode("span", null, "附件：", -1)), _createElementVNode("a", {
        href: newsDetail.value.attachment,
        target: "_blank"
      }, "下载附件", 8, _hoisted_11)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("返回列表", -1)]))]),
        _: 1
      })])]))]), _createVNode(_component_Footer)]);
    };
  }
});